import { useCallback, useEffect, useState } from "react";
import { getWeeklyStaffScheduling } from "../api/staffSchedulingApi";

export default function useWeeklyStaffScheduling(weekStart, campusName, options = {}) {
  const { enabled = true } = options;

  const [data, setData] = useState({
    campus: campusName || "",
    weekStart: weekStart || "",
    weekEnd: "",
    days: [],
    rows: [],
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    if (!enabled || !weekStart || !campusName) {
      setData({
        campus: campusName || "",
        weekStart: weekStart || "",
        weekEnd: "",
        days: [],
        rows: [],
      });
      setError("");
      setLoading(false);
      return;
    }

    setLoading(true);
    setError("");

    try {
      const result = await getWeeklyStaffScheduling(campusName, weekStart);
      setData({
        campus: result?.campus || campusName,
        weekStart: result?.weekStart || weekStart,
        weekEnd: result?.weekEnd || "",
        days: Array.isArray(result?.days) ? result.days : [],
        rows: Array.isArray(result?.rows) ? result.rows : [],
      });
    } catch (err) {
      setError(err?.message || "Failed to load weekly staff scheduling");
    } finally {
      setLoading(false);
    }
  }, [enabled, weekStart, campusName]);

  useEffect(() => {
    load();
  }, [load]);

  return {
    data,
    loading,
    error,
    refresh: load,
  };
}